import { defineStore } from "pinia";
import { cloneDeep } from "lodash-es";
import { getElementsGroupById } from "@/helpers/utils";

// This store will manage the form state and actions
export const useFormStore = defineStore("form", {
  state: () => ({
    // Complete form data from API response
    formData: {},

    // Form processing state
    formElements: [],
    isSubmitted: false,
    copyOfFormElements: [],
    formElementMap: {},
    sessionId: null,

    // Page navigation state
    currentPage: 0,
    pageTransitionName: "next-page",
    history: [],
    targetPageIndex: -1,
  }),

  getters: {
    formId: (state) => state.formData.id,
    configuration: (state) => state.formData.accessSettings || {},
    styling: (state) => state.formData.styling || {},
    rules: (state) => state.formData.rules || [],
    scripts: (state) => state.formData.scripts || [],
    variables: (state) => state.formData.formVariablesAttributes || [],
    translations: (state) => state.formData.formTranslationsAttributes || [],
    pages: (state) => state.formData.formPages || [],
    formBuilder: (state) => state.formData.formBuilder || [],
    isFreeUser: (state) => state.formData.isFreeUser || false,
    hasTrustedFormCertificate: (state) =>
      state.formData.hasTrustedFormCertificate || false,
  },

  actions: {
    setFormData(data) {
      this.formData = {
        ...data,
        rules: Array.isArray(data.rules) ? data.rules : [],
        scripts: Array.isArray(data.scripts) ? data.scripts : [],
      };
    },

    setFormElements(elements) {
      this.formElements = elements;
    },

    clearFormElements() {
      this.formElements = [];
    },

    updateFormElements(elements) {
      this.$patch((state) => {
        state.formElements = elements;
        state.copyOfFormElements = cloneDeep(elements);
        state.formElementMap = getElementsGroupById(elements);
      });
    },

    navigateToPage(pageIndex) {
      this.currentPage = pageIndex;
    },

    setPageTransition(transitionName) {
      this.pageTransitionName = transitionName;
    },

    navigateNext(pageIndex, targetPageIndex) {
      this.$patch((state) => {
        state.pageTransitionName = "next-page";
        state.history.push(pageIndex);
        state.currentPage =
          targetPageIndex && targetPageIndex !== -1
            ? targetPageIndex
            : pageIndex + 1;
        state.targetPageIndex = -1;
      });
    },

    navigatePrevious() {
      this.$patch((state) => {
        state.pageTransitionName = "prev-page";
        state.currentPage = state.history.pop() || 0;
      });
    },

    setTargetPageIndex(index) {
      this.targetPageIndex = index;
    },

    setSubmitted(isSubmitted) {
      this.isSubmitted = isSubmitted;
    },

    setSessionId(sessionId) {
      this.sessionId = sessionId;
    },

    resetFormElements() {
      this.$patch({
        formElements: [],
        copyOfFormElements: [],
        formElementMap: {},
      });
    },

    resetNavigation() {
      this.$patch({
        currentPage: 0,
        history: [],
        targetPageIndex: -1,
        pageTransitionName: "next-page",
      });
    },
  },
});
